export default __webpack_public_path__ + "static/media/step3-6.399e74f2.png";